/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  Images  */
import { ReactComponent as AuvikANMLogoLight } from 'images/logo/ANM/auvik-logo-dark-bg.svg';
import { ReactComponent as AuvikANMLogoImage } from 'images/logo/ANM/auvik-logo.svg';
import { ReactComponent as AuvikASMLogoImage } from 'images/logo/SVG/Auvik-ASM-Logo-Full-color-RGB.svg';
import { ReactComponent as AuvikASMLogoLight } from 'images/logo/SVG/Auvik-ASM-Logo-Full-color-Rev-Lt-RGB.svg';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AuvikASMLogo = ({ lightColor, style }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    if (lightColor) {
        return (
            <AuvikASMLogoLight
                data-testid="auvikASMLogoLight"
                alt={t('Logo.forASM')}
                style={{ width: '150px', ...style }}
            />
        );
    }

    return userTheme === 'dark' ? (
        <AuvikASMLogoLight
            data-testid="auvikASMLogoLight"
            alt={t('Logo.forASM')}
            style={{ width: '150px', ...style }}
        />
    ) : (
        <AuvikASMLogoImage
            data-testid="auvikASMLogo"
            alt={t('Logo.forASM')}
            style={{ width: '150px', ...style }}
        />
    );
};

export const AuvikANMLogo = ({ lightColor, style }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    if (lightColor) {
        return (
            <AuvikANMLogoLight
                data-testid="auvikANMLogoLight"
                alt={t('Logo.forANM')}
                style={{ width: '150px', ...style }}
            />
        );
    }

    return userTheme === 'dark' ? (
        <AuvikANMLogoLight
            data-testid="auvikANMLogoLight"
            alt={t('Logo.forANM')}
            style={{ width: '150px', ...style }}
        />
    ) : (
        <AuvikANMLogoImage
            data-testid="auvikANMLogo"
            alt={t('Logo.forANM')}
            style={{ width: '150px', ...style }}
        />
    );
};
